export default __webpack_public_path__ + "locales/finances.kk.json";